import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import References from './components/References';
import './App.css';
import MemberDetail from './components/MemberDetail';
import { HashLink } from 'react-router-hash-link';
import Footer from './components/Footer'; 
import Navbar from './components/Navbar';


function App() {
 
  return (
    <>
    <Router>
      <header>
        <HashLink className="logo" smooth to="/#top" scroll={el => {
    const yOffset = -100; // säätö headerin korkeuden mukaan
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }}><h1>Lumo Ensemble</h1></HashLink>
        <Navbar />
      </header>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/references" element={<References />} />
        {/* dynaaminen reitti jäsenelle */}
        <Route path="/member/:id" element={<MemberDetail />} />
      </Routes>
    </Router>
    <Footer />
    </>
  
  );
}

export default App;


      
